
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 19 20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.874 15l-2.71-4.68a7 7 0 10-12.32 0L.134 15a1 1 0 00.87 1.5h2.87l1.46 2.46c.05.081.11.156.18.22a1 1 0 00.69.28h.14a1 1 0 00.73-.49l1.93-3.32 1.93 3.35a.999.999 0 00.73.48h.14a1 1 0 00.7-.28.872.872 0 00.17-.21l1.46-2.46h2.87a1 1 0 00.87-.5 1 1 0 000-1.03zm-11.68 1.53l-.89-1.49a1 1 0 00-.85-.49h-1.73l1.43-2.48a7 7 0 003.57 1.84l-1.53 2.62zM9.004 12a5 5 0 110-9.999 5 5 0 010 9.999zm4.55 2.55a1 1 0 00-.85.49l-.89 1.49-1.52-2.65a7.06 7.06 0 003.56-1.84l1.43 2.48-1.73.03z"}})])
          )
        }
      }
    